import dynamic from 'next/dynamic'
import { useAdminCookie } from '../../contexts'

export const OttAdminBarLoader = () => {
  const admin_cookie = useAdminCookie()
  if (!admin_cookie) {
    return null
  }
  const AdminBar = dynamic(() => import('./OttAdminBar'), { ssr: false })
  return <AdminBar />
}
export default OttAdminBarLoader
